export const enumValueToSelectOption = (value: string) => {
  const temp = value.toLowerCase().replaceAll('_', '-');

  return temp.charAt(0).toUpperCase() + temp.slice(1);
};
